import { useCallback } from 'react';

import { TOPIC } from 'Util/Message/TopicName';
import postMessageHelper from 'Util/Message/postMessageHelper';

import useTracking from './useTracking';

const CATEGORY = 'MyPath';

const MYPATH_ACTIONS = {
  CLICK: 'Click to open MyPath',
  ONBOARDING_CLICK: 'Click to open MyPath Onboarding by TCAS User',
};

export const getMyPathToggleEvent = (action, label) => ({
  category: CATEGORY,
  action,
});

function useMyPathTracking() {
  const { logAction } = useTracking();

  const logMyPathClick = useCallback(() => {
    logAction(getMyPathToggleEvent(MYPATH_ACTIONS.CLICK));
    postMessageHelper(TOPIC.MYPATH_CLICKED);
  }, [logAction]);

  const logOnboardingClick = useCallback(() => {
    logAction(getMyPathToggleEvent(MYPATH_ACTIONS.ONBOARDING_CLICK));
    postMessageHelper(TOPIC.MYPATH_ONBOARDING_CLICKED);
  }, [logAction]);

  return {
    logMyPathClick,
    logOnboardingClick,
  };
}

export { useMyPathTracking };
